import { Stack, useMediaQuery, useTheme } from '@mui/material';

import HapvidaLogo from '@hapvida/hapvida-core-components/src/assets/images/hapvida-logo.svg';

import HapvidaLogoLight from '@hapvida/hapvida-core-components/src/assets/images/hapvida-logo-white.svg';

import {
  DrawerHeaderContainer,
  DrawerToggleButton,
  IconButton,
  StyledAvatar,
  StyledStack,
  Username,
} from './styles';
import { useSidebar } from '../../hooks';
import { Icon } from '@hapvida/hapvida-core-components';
import menuIcon from '@assets/images/menu-icon.svg';
import menuIconDefault from '@assets/images/menu-icon-default.svg';
import type { SidebarHeaderProps } from './types';
import { useCallback } from 'react';
import { NEW_COLORS } from '../../../../themes/colors/newColors';

export function SidebarHeader({
  isColorful = true,
  userName,
  url,
  onClickLogo,
}: Readonly<SidebarHeaderProps>) {
  const { toggleDrawer, drawerOpen } = useSidebar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const renderUserInitals = useCallback(() => {
    if (userName) {
      const [name, lastname] = userName.split(' ');

      if (name && lastname) {
        return `${name[0]}${lastname[0]}`;
      }

      if (name) {
        return name[0];
      }
    }
  }, [userName]);

  const isBackofficeMobile = isMobile && !isColorful;

  return (
    <DrawerHeaderContainer>
      {drawerOpen &&
        (isMobile ? (
          <Stack
            justifyContent="space-between"
            flexDirection="row"
            alignItems="center"
            width="100%"
          >
            <Stack flexDirection="row" alignItems="center" gap={1}>
              <StyledAvatar
                src={url}
                alt={userName}
                isBackofficeMobile={isBackofficeMobile}
              >
                {renderUserInitals()}
              </StyledAvatar>
              <Username
                variant="subtitle1"
                color={
                  isColorful ? NEW_COLORS.PRIMARY[500] : NEW_COLORS.BASE.WHITE
                }
              >
                {userName}
              </Username>
            </Stack>
            <IconButton
              onClick={toggleDrawer}
              disableRipple
              style={{ flex: drawerOpen ? 0 : 1 }}
            >
              <Icon
                color={NEW_COLORS.SECONDARY[500]}
                name="actions-b2b-close"
              />
            </IconButton>
          </Stack>
        ) : (
          <StyledStack
            paddingX={2}
            flexDirection="row"
            gap={2}
            onClick={onClickLogo}
          >
            <img
              src={isColorful ? HapvidaLogo : HapvidaLogoLight}
              alt="Hapvida"
              height={56}
            />
          </StyledStack>
        ))}
    </DrawerHeaderContainer>
  );
}
